import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { usePublishPostMutation } from 'api';
import { PollFormValues, PostDraft } from 'types';

import { formValuesAdapter } from '../adapter';

interface UseCreatePollFormProps {
  draft: PostDraft | null;
  onClose?: () => void;
}

export function useCreatePollForm({ draft, onClose }: UseCreatePollFormProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    publishPostMutation: createPollMutation,
    isLoading,
    isSuccess,
  } = usePublishPostMutation({
    successText: t('toasts.poll.success.create'),
  });

  const handleSubmit = useCallback(
    async (data: PollFormValues, attachmentIds: string[]) => {
      await createPollMutation({
        postId: draft?.id ?? '',
        post: {
          ...formValuesAdapter(data),
          ...(!!attachmentIds.length && { file_ids: attachmentIds }),
        },
      });
    },
    [createPollMutation, draft],
  );

  useEffect(() => {
    if (isSuccess) onClose ? onClose() : navigate(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return {
    handleSubmit,
    isLoading,
  };
}
